export default class HladilnikObj {
    kombo_energy = [
        [146,	208,	291,	382,	520,	624,	694,	763],
        [155,	222,	311,	408,	556,	667,	741,	816],
        [151,	215,	301,	394,	537,	644,	716,	787],
        [158,	226,	316,	414,	565,	678,	753,	829],
        [137,	195,	272,	357,	486,	584,	649,	713],
        [151,	216,	302,	395,	539,	647,	719,	791],
        [144,	205,	286,	375,	512,	614,	682,	750],
        [148,	211,	296,	387,	528,	634,	704,	775],
        [143,	204,	286,	374,	511,	613,	681,	749],
        [132,	189,	265,	347,	473,	568,	631,	694],
        [134,	191,	268,	350,	478,	573,	637,	701],
        [123,	176,	247,	323,	440,	528,	587,	646],
        [111,	159,	222,	291,	397,	476,	529,	582],
        [118,	169,	236,	309,	421,	506,	562,	618],
        [111,	159,	222,	291,	397,	476,	529,	582],
        [105,	150,	210,	275,	375,	450,	500,	550],
        [103,	147,	206,	270,	369,	442,	491,	541],
        [98,	140,	196,	257,	350,	420,	467,	514],
    ];    

    kombo_strings = [
        "200 cm - 245 l hladilnika - 75 l zamrzovlanika",
        "200 cm - 278 l hladilnika - 86 l zamrzovalnika",
        "200 cm - 245 l hladilnika - 86 l zamrzovalnika",
        "186 cm - 211 l hladilnika - 118 l zamrzovalnika",
        "180 cm - 223 l hladilnika - 61 l zamrzovalnika",
        "180 cm - 205 l hladilnika - 103 l zamrzovalnika",
        "180 cm - 230 l hladilnika - 75 l zamrzovalnika",
        "180 cm - 230 l hladilnika - 86 l zamrzovalnika",
        "180 cm - 20  l hladilnika -86 l zamrzovalnika" ,
        "156 cm - 205 l hladilnika - 59 l zamrzovalnika",
        "144 cm - 190 l hladilnika - 68 l zamrzovalnika",
        "144 cm - 247 l hladilnika - 21 l zamrzovalnika",
        "125 cm - 183 l hladilnika - 17 l zamrzovalnika",
        "123 cm - 145 l hladilnika - 48 l zamrzovalnika",
        "113 cm - 134 l hladilnika - 36 l zamrzovalnika",
        "104 cm - 145 l hladilnika - 17 l zamrzovalnika",
        "85 cm - 124 l hladilnika - 21 l zamrzovalnika",
        "85 cm - 103 l hladilnika -	17 l zamrzovalnika",
    ];

    fridge_energy = [
        [71,	101,	141,	184,	252,	302,	335,	369],
        [69,	98,	    137,	179,	244,	293,	326,	358],
        [65,	93,	    131,	171,	233,	280,	311,	342],
        [62,	89,	    124,	163,    222,	266,	296,	325],
        [59,	84, 	118,	155,	211,	253,	281,	309],
    ];

    fridge_strings = [
        "180 cm - 388 l hladilnika",
        "180 cm - 346 l hladilnika",
        "144 cm - 284 l hladilnika",
        "125 cm - 217 l hladilnika",
        "85 cm - 156 l hladilnika",
    ];

    ratings = [
        "A+++ (po 2002)",
        "A++ (po 2002)",
        "A+ (po 2002)",
        "A (po 2002)",
        "B (1996-2002)",
        "C (1992-1995)",
        "D (pred 1992)",
        "E (pred 1992)",
    ];

    static curr_use;
    static new_use
    static savings;
    static curr_price;
    static new_price;

    ukrep1;
    ukrep1_savings;
    new_type;
    new_size;
    new_rating;

    ukrep2;
    ukrep2_savings;

    ukrep3;
    ukrep3_savings;

    ukrep4;
    ukrep4_savings;

    ukrep5;
    ukrep5_savings;

    constructor(type, size, rating) {
        this.type = type;
        this.size = size;
        this.rating = rating;
        this.st_select = 1;
        this.short = "H";
        this.st_ukrepov = 0;
        this.name = "Hladilnik";

        switch (type) {    
            case "1":
                console.log("sem v fridge case");
                this.curr_use = this.fridge_energy[size-1][rating-1];
                this.size_string = this.fridge_strings[size-1];
                console.log(this.size_string);
                break;
            case "2":
                console.log("sem v kombu case");
                this.curr_use = this.kombo_energy[size-1][rating-1];
                this.size_string = this.kombo_strings[size-1];           
                console.log(this.size_string);
                break;  
        }

        this.detail_string = this.size_string.concat(this.ratings[rating-1]);
    }

    
}